var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddChaticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 15.5H25V12.1667H11.6667V15.5ZM11.6667 22.1667H20V18.8333H11.6667V22.1667ZM28.3333 33.8333V28.8333H23.3333V25.5H28.3333V20.5H31.6667V25.5H36.6667V28.8333H31.6667V33.8333H28.3333ZM5 33.8333V8.83334C5 7.91667 5.32667 7.13167 5.98 6.47834C6.63333 5.825 7.41778 5.49889 8.33333 5.5H28.3333C29.25 5.5 30.035 5.82667 30.6883 6.48C31.3417 7.13334 31.6678 7.91778 31.6667 8.83334V17.2917C31.3889 17.2361 31.1111 17.2011 30.8333 17.1867C30.5556 17.1722 30.2778 17.1656 30 17.1667C27.1944 17.1667 24.8261 18.1389 22.895 20.0833C20.9639 22.0278 19.9989 24.3889 20 27.1667C20 27.4444 20.0072 27.7222 20.0217 28C20.0361 28.2778 20.0706 28.5556 20.125 28.8333H10L5 33.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddChaticon);
export default __webpack_public_path__ + "static/media/addChat.icon.bf3ada7f7d728fe68b9d4d98c4be027b.svg";
export { ForwardRef as ReactComponent };